import { LocalStorageRepository } from '@warehouse/shared/util';
import { QB_AUTH_BOUNCE_AT_KEY, QB_AUTH_BOUNCE_COOLDOWN_MS, QB_EMBED_MESSAGE_TYPE } from '../quickbase-types';

export function markAutoBounce(storage: LocalStorageRepository, now: number = Date.now()): void {
	storage.set(QB_AUTH_BOUNCE_AT_KEY, String(now));
}

/** One automatic redirect per cooldown window, so a browser that cannot hold the session never loops. */
export function canAutoBounce(storage: LocalStorageRepository, now: number = Date.now()): boolean {
	const last = Number(storage.get(QB_AUTH_BOUNCE_AT_KEY));
	return !Number.isFinite(last) || last === 0 || now - last > QB_AUTH_BOUNCE_COOLDOWN_MS;
}

// Clear the cooldown: on a confirmed session so the next no-session tab is not trapped, and on a manual retry.
export function clearAutoBounce(storage: LocalStorageRepository): void {
	storage.remove(QB_AUTH_BOUNCE_AT_KEY);
}

export function isEmbedAuthedMessage(candidate: unknown): boolean {
	if (typeof candidate !== 'object' || candidate === null) return false;
	const message = candidate as { type?: unknown; status?: unknown };
	return message.type === QB_EMBED_MESSAGE_TYPE && message.status === 'authed';
}

export function safeOrigin(url: string | null | undefined): string | null {
	if (!url) return null;
	try {
		return new URL(url, window.location.href).origin;
	} catch {
		return null;
	}
}
